import { omit } from 'ramda';
import { toError } from '../private-site/parsers/error';
import { toSearchResults } from './mappers/search-results';
export const initSearch = (settings, http) => {
  const search = function (query, options) {
    if (options === void 0) {
      options = {};
    }
    const {
      apiUrl,
      siteFilesSettings
    } = settings;
    const privateMediaApi = (siteFilesSettings == null ? void 0 : siteFilesSettings.apiUrl) || apiUrl;
    const queryParams = {
      query,
      site_token: settings.siteMediaToken
    };
    const {
      publicMediaCategories
    } = options;
    const searchOptions = omit(['publicMediaCategories'], options);
    return http.post(`${privateMediaApi}/v3/search/multi`, {
      ...queryParams,
      ...searchOptions
    }, null, {
      headers: options.headers || {},
      withCredentials: true
    }).then(res => ({
      recentSearches: res.data.searches,
      results: toSearchResults(res.data, {
        publicMediaCategories,
        siteToken: settings.siteMediaToken
      })
    })).catch(toError);
  };
  return {
    search
  };
};